export class AddressModel {
  fullAddress: string;
  addressExtId: string;
  name: string;

  constructor(params?: AddressModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
